import Cookies from "js-cookie";
import {
  axiosInstance,
  GET_ALL_OVERALL_COURSE_TEST,
  GET_OVERALL_COURSE_TEST_BY_ID,
  SUBMIT_OVERALL_COURSE_TEST,
  GET_OVERALL_COURSE_TEST_SUBMISSION,
  GET_OVERALL_COURSE_TEST_PENDING_COUNT,
} from "../apiurls/apiurls";

export const getPendingOverallCourseTestCount = async (courseKey) => {
  const token = Cookies.get("accessToken");
  if (!token) {
    return 0;
  }
  try {
    const response = await axiosInstance.get(
      GET_OVERALL_COURSE_TEST_PENDING_COUNT,
      { params: { course_key: courseKey } },
    );
    return response?.data;
  } catch (error) {
    console.error("Failed to fetch pending overall course test count", error);
    throw error;
  }
};

export const getAllOverallCourseTests = async (params) => {
  try {
    const response = await axiosInstance.get(GET_ALL_OVERALL_COURSE_TEST, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching all overall course tests:", error);
    throw error;
  }
};

export const getOverallCourseTestById = async (id) => {
  try {
    const response = await axiosInstance.get(GET_OVERALL_COURSE_TEST_BY_ID, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching overall course test by ID:", error);
    throw error;
  }
};

export const submitOverallCourseTest = async (id, payload) => {
  try {
    const response = await axiosInstance.post(
      `${SUBMIT_OVERALL_COURSE_TEST}?id=${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting overall course test:", error);
    throw error;
  }
};

export const getOverallCourseTestSubmission = async (testId) => {
  try {
    const response = await axiosInstance.get(
      GET_OVERALL_COURSE_TEST_SUBMISSION,
      {
        params: { test_id: testId },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching overall course test submission:", error);
    throw error;
  }
};
